import * as React from 'react';
import { LineChart, Line, CartesianGrid, ResponsiveContainer, YAxis, XAxis, Tooltip, TooltipProps, Label } from 'recharts';
import formatToDisplay, { format as formatToDisplayWithoutCurrency } from '../../lib/numbers/formatToDisplay';
import { i18n } from '../../i18n';

const renderTooltip = (tooltipProps: TooltipProps) => {
  if (!tooltipProps.payload) {
    return;
  }

  const year = tooltipProps.label;
  const predictedReturns = tooltipProps
    .payload
    .sort((a, b) => {
      const x = a.value;
      const y = b.value;
      return (x > y) ? -1 : ((x < y) ? 1 : 0);
    })
    .map(payload => ({ name: payload.name, value: formatToDisplay(payload.value as number) }))

  return (
    <div className='graph-tooltip'>
      <h6>{year}</h6>
      {predictedReturns.map(item => <p key={item.name}><span>{i18n.t(`tool.results.${item.name.toLowerCase()}`)}:</span> {item.value}</p>)}
    </div>
  );
}

export default (props: any) => (
  <div className='graph'>
    <ResponsiveContainer width='100%' height='100%'>
      <LineChart data={props.data}>
        <CartesianGrid vertical={false} />
        <XAxis dataKey='xaxis' minTickGap={40} tickMargin={13} height={53}>
          <Label value={i18n.t('tool.results.x_axis_label')} position='insideBottom' />
        </XAxis>
        <YAxis tickFormatter={formatToDisplayWithoutCurrency} tickMargin={13} width={73}>
          <Label value={i18n.t('tool.results.y_axis_label')} angle={270} position='insideLeft' dy={53} />
        </YAxis>
        <Tooltip content={renderTooltip} />
        <Line
          type='monotone'
          strokeDasharray='8 12'
          dot={false}
          dataKey='high'
          className='line line-high' />
        <Line
          type='monotone'
          strokeDasharray='8 12'
          dot={false}
          dataKey='low'
          className='line line-low' />
        <Line
          type='monotone'
          dot={false}
          dataKey='medium'
          className='line line-medium' />
      </LineChart>
    </ResponsiveContainer>
  </div>
);
